// IMPORTS

// local
import { VOTING_ESCROW_STRINGS } from "./governanceConfig"
import VotingEscrow from "./votingEscrow"

// global
import { FIXED_3_SCALE_FACTOR, FIXED_12_SCALE_FACTOR, SECONDS_PER_YEAR } from "../../globals"

export default class UserVotingEscrowState {
  public votingEscrow: VotingEscrow
  public amountLocked: number
  public lockStartTime: number
  public lockDuration: number
  public lockEndTime: number
  public lockDurationRemaining: number
  public lockDurationRemainingYears: number
  public amountVeBank: number
  public boostMultiplier: number
  
  public projAmountVeBank: number
  public projBoostMultiplier: number

  /**
   * Constructor for the user voting escrow class.
   * 
   * @param userLocalState - a dictionary representing a user's local state with
   * the voting escrow contract.
   */
  constructor(userLocalState: {}, votingEscrow: VotingEscrow) {
    this.votingEscrow = votingEscrow
    this.amountLocked = userLocalState[VOTING_ESCROW_STRINGS.user_amount_locked]
    this.lockStartTime = userLocalState[VOTING_ESCROW_STRINGS.user_lock_start_time]
    this.lockDuration = userLocalState[VOTING_ESCROW_STRINGS.user_lock_duration]
    this.lockEndTime = this.lockStartTime + this.lockDuration
    this.lockDurationRemaining = Math.max(0, this.lockEndTime - (Date.now()/1000))
    this.lockDurationRemainingYears = this.lockDurationRemaining / SECONDS_PER_YEAR
    this.amountVeBank = userLocalState[VOTING_ESCROW_STRINGS.user_amount_vebank]
    this.boostMultiplier = userLocalState[VOTING_ESCROW_STRINGS.user_boost_multiplier]
  
    // projected values
    let [projAmountVeBank, projBoostMultiplier] = this.getProjValues(this.amountLocked, this.lockDurationRemaining)
    this.projAmountVeBank = projAmountVeBank
    this.projBoostMultiplier = projBoostMultiplier
  }

  getProjValues(amountLocked: number, durationRemaining: number): [number, number] {
    // TODO fix denom
    let projAmountVeBank = Math.max(0, amountLocked * durationRemaining / SECONDS_PER_YEAR)
    let projBoostMultiplier = Math.max(0, (projAmountVeBank * FIXED_12_SCALE_FACTOR / this.votingEscrow.totalVebank) || 0)
    return [projAmountVeBank, projBoostMultiplier]
  }
}
